var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEncashment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "50%",
    x2: "50%",
    y1: "128.957%",
    y2: "-34.929%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7190C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#031266"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C466C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D27497"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M8.8-2.4h12.168c.442 0 .8.358.8.8v27.2c0 .442-.358.8-.8.8H8.8c-.442 0-.8-.358-.8-.8V-1.6c0-.442.358-.8.8-.8z",
    transform: "rotate(90 14.884 12)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.2,
    cy: 5.6,
    r: 5.6,
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    stroke: "#89489B",
    strokeWidth: 0.7,
    opacity: 0.816
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncashment);
export default __webpack_public_path__ + "static/media/encashment.3f0e7abbc7fe4f1b6e77c2a1da1192ea.svg";
export { ForwardRef as ReactComponent };